import "./src/assets/css/main.css"
import "./src/assets/css/components.css"
import "./src/assets/css/animations.css"

export const onServiceWorkerUpdateReady = () => {
  const answer = window.confirm(
    `This application has been updated. ` +
      `Reload to display the latest version?`
  )

  if (answer === true) {
    window.location.reload()
  }
}